import React from 'react'

export const AuthLayout = ({ children }) => {
  return <div className="auth-container">{children}</div>
}

export default AuthLayout
